"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _formatAddress = _interopRequireDefault(require("../../../utils/formatAddress"));
var _formatName = _interopRequireDefault(require("../../../utils/formatName"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _BillingAddress = _interopRequireDefault(require("./BillingAddress.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BillingAddress = _ref => {
  let {
    lang
  } = _ref;
  const {
    cart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    address: {
      billing
    } = {},
    isGuest = false
  } = cart || {};
  const {
    countryCode,
    countryTitle,
    company,
    firstName,
    lastName,
    stateTitle,
    street,
    title,
    town,
    zipCode
  } = billing || {};
  const name = (0, _formatName.default)({
    firstName,
    lastName,
    title
  });
  const address = (0, _formatAddress.default)({
    countryTitle,
    countryCode,
    stateTitle,
    street,
    town,
    zipCode
  });
  const navigate = (0, _useLink.default)();
  const css = (0, _BillingAddress.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.billingAddress, "mco-shop-checkout-billing-address")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.header, "mco-shop-checkout__header")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-shop-checkout__headline")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.checkout.billingAddress.headline",
    l: l
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: (0, _clsx.default)(css.editButton, "mco-shop-checkout-billing-address__edit-button"),
    onClick: () => navigate(isGuest ? "/".concat(lang, "/shop/checkout/addresses/guest/new") : "/".concat(lang, "/shop/checkout/addresses/billing"))
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "/img/icons/shop/edit.svg",
    size: 24
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, billing ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (company || name) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.title, "mco-shop-checkout-billing-address__title"),
    dangerouslySetInnerHTML: {
      __html: company || name
    },
    variant: "body1"
  }), company && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.name, "mco-shop-checkout-billing-address__name"),
    dangerouslySetInnerHTML: {
      __html: name
    },
    variant: "body2"
  })), address && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.address, "mco-shop-checkout-billing-address__address"),
    dangerouslySetInnerHTML: {
      __html: address
    },
    variant: "body2"
  })) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.checkout.billingAddress.message",
    l: l
  }))));
};
var _default = exports.default = BillingAddress;